import config from 'config'
import { getJsonHeaders } from './helpers'

export async function getUsage() {
  const res = await fetch(config.API_URL + '/iapi/media/ai/usage', {
    headers: await getJsonHeaders(),
    credentials: 'include',
  })
  return { ok: res.ok, body: await res.json() }
}

export async function generate({ prompt, history, aspectRatio }) {
  const res = await fetch(config.API_URL + '/iapi/media/ai/generate', {
    method: 'POST',
    headers: await getJsonHeaders(),
    credentials: 'include',
    body: JSON.stringify({
      prompt,
      aspect_ratio: aspectRatio || undefined,
      history: history || undefined,
    }),
  })
  return { ok: res.ok, status: res.status, body: await res.json() }
}

export async function importImage({ image, format, prompt, folderId }) {
  const res = await fetch(config.API_URL + '/iapi/media/ai/import', {
    method: 'POST',
    headers: await getJsonHeaders(),
    credentials: 'include',
    body: JSON.stringify({
      image,
      format,
      prompt,
      folder_id: folderId || undefined,
    }),
  })
  return { ok: res.ok, status: res.status, body: await res.json() }
}
